import {
  PaymentMethod,
  SubscriptionServiceSubscription
} from '../types/models/SubscriptionServiceSubscription'
import { Plan, PlanExtra } from '@dtx-company/true-common/src/types/Plan'
import { PaymentMethod as StripePaymentMethod } from '@stripe/stripe-js'
import { Subscription } from '../../../types/subscription'
import { convertSubscriptionCardToPaymentMethod } from '@app/common/src/components/PlanPurchaseExperience/utils/convertSubscriptionCardToPaymentMethod'
import { subscriptionServiceDateStringToDate } from '../../../utils/misc/subscriptionServiceDateStringToDate'
import { toPlanExtraDetails } from './toPlanExtraDetails'
import { toSubscriptionStatus } from './toSubscriptionStatus'

export const GET_SUBSCRIPTIONS_URL = '/v2/subscriptions'
export const SUBSCRIPTIONS_URL_V3 = '/v2/subscriptions'

export function migrateSubscriptions(
  jsonSubscriptions: SubscriptionServiceSubscription[],
  plans: Plan[]
): Subscription[] {
  const planExtras = plans.reduce<PlanExtra[]>((allPlanExtras, plan) => {
    return [...allPlanExtras, ...(plan.planExtras || [])]
  }, [])
  return jsonSubscriptions.map(jsonSubscription => {
    const plan = plans.find(plan => plan.id === jsonSubscription.planId)
    if (!plan) {
      throw Error(`Plan with ID ${jsonSubscription.planId} doesn't exist`)
    } else {
      return {
        id: jsonSubscription.subscriptionId,
        planId: jsonSubscription.planId,
        plan,
        paymentMethodId:
          jsonSubscription.paymentMethodId || jsonSubscription.paymentMethod?.id || undefined,
        status: toSubscriptionStatus(jsonSubscription.subscriptionStatus),
        planExtraDetails: toPlanExtraDetails(jsonSubscription.planExtraDetails, planExtras),
        eligibleForFreeMonth: jsonSubscription.eligibleForFreeMonth,
        queuedDowngradePlanId: jsonSubscription.queuedDowngradePlanId || undefined,
        cancelAtPeriodEnd: jsonSubscription.cancelAtPeriodEnd,
        paymentMethod: convertPaymentMethod(jsonSubscription.paymentMethod),
        nextPaymentDate: subscriptionServiceDateStringToDate(jsonSubscription.billingCycleEnd, {
          apiName: GET_SUBSCRIPTIONS_URL
        }),
        queuedPlan: plans.find(plan => plan.id === jsonSubscription.queuedDowngradePlanId),
        trialEndAt: subscriptionServiceDateStringToDate(jsonSubscription.trialEndAt, {
          apiName: GET_SUBSCRIPTIONS_URL
        })
      }
    }
  })
}

const convertPaymentMethod = (
  paymentMethod?: PaymentMethod | null
): StripePaymentMethod | undefined => {
  if (!paymentMethod) {
    return undefined
  }
  return {
    ...convertSubscriptionCardToPaymentMethod(paymentMethod.cardInfo),
    id: paymentMethod.id,
    type: paymentMethod.methodType
  }
}
